<template>
    <div>
        <div class="spinner"></div>
    </div>
</template>

<script>
    import Vue from 'vue';
    import Component from 'vue-class-component';
    import { GET_PENDING_EVALUATIONS } from '@/store/modules/pending-evaluations';
    @Component({})
    export default class NextRedirect extends Vue {
        mounted() {
            this.loading = true;
            this.$store.dispatch(GET_PENDING_EVALUATIONS, {}).then(pendingEvaluations => {
                return this.goToNextEvaluation_Pending(pendingEvaluations);
            });
        }

        goToNextEvaluation_First(pendingEvaluations) {
            if (pendingEvaluations.length) {
                // Go to the first pending evaluation
                const evaluation = pendingEvaluations[0];
                if (evaluation.id == this.$route.params.evaluation_id) return this.$router.replace({ name: 'evaluation-students' });
                if (!evaluation.pending) this.$router.replace({ name: 'evaluation-students' });
                this.$router.replace({ name: 'evaluation-student', params: {
                    user_id: evaluation.student.id,
                    diploma_id: evaluation.diploma.diploma_id,
                    work_process_id: evaluation.work_process.work_process_id,
                    evaluation_id: evaluation.id
                }});
            } else {
                // Go to home page (list of all students)
                this.$router.replace({ name: 'evaluation-students' });
            }
        }

        goToNextEvaluation_Pending(pendingEvaluations) {
            // Loop through pending evaluations and find this one
            this.loading = true;
            let thisEvaluationIndex = -1;
            pendingEvaluations.forEach((evaluation, index) => {
                if (evaluation.id == this.$route.params.evaluation_id) thisEvaluationIndex = index;
            });
            // If this evaluation was previously pending, go to the next one
            if (thisEvaluationIndex > -1) {
                if (pendingEvaluations.length > (thisEvaluationIndex + 1)) {
                    // There is a next evaluation available
                    const evaluation = pendingEvaluations[thisEvaluationIndex + 1];
                    if (evaluation.id == this.$route.params.evaluation_id) return this.$router.replace({ name: 'evaluation-students' });
                    this.$router.replace({ name: 'evaluation-student', params: {
                        user_id: evaluation.student.id,
                        diploma_id: evaluation.diploma.diploma_id,
                        work_process_id: evaluation.work_process.work_process_id,
                        evaluation_id: evaluation.id
                    }});
                } else {
                    // There is no next evaluation, go to the first available evaluation
                    return this.goToNextEvaluation_First(pendingEvaluations);
                }
            } else {
                // This evaluation was not found, go to the first available evaluation
                return this.goToNextEvaluation_First(pendingEvaluations);
            }
        }
    }

    Vue.component('next-redirect', NextRedirect);
</script>



// WEBPACK FOOTER //
// src/pages/NextRedirect.vue